// extracted by mini-css-extract-plugin
export default {"section-wrapper":"Section_section-wrapper__bkhZC","background":"Section_background__SCuoY","floating-item":"Section_floating-item__Mrh1o"};